import { CLEAR_SITE_DATA } from '../application';
import {
  LOADING_STATE_SETS,
  SAVE_STATE_SET,
  STATE_SET_SAVED,
  RECEIVED_STATE_SETS,
  UPDATE_STATE_SETS,
} from './actions';

// INITAL STATES

const initalState = {
  loadingSaveStateSet: false,
  loadingStates: false,
  stateSets: [],
  siteLoaded: undefined,
};

export const reducer = (state = structuredClone(initalState), action) => {
  switch (action.type) {
    case SAVE_STATE_SET: {
      return { ...state, loadingSaveStateSet: true };
    }
    case STATE_SET_SAVED: {
      return { ...state, loadingSaveStateSet: false };
    }
    case LOADING_STATE_SETS: {
      return { ...state, loadingStates: true };
    }
    case RECEIVED_STATE_SETS: {
      return {
        ...state,
        loadingStates: false,
        stateSets: action.stateSets,
        siteLoaded: action.siteId || state.siteLoaded,
      };
    }
    case UPDATE_STATE_SETS: {
      return {
        ...state,
        loadingSaveStateSet: true,
        stateSet: action.stateSet,
      };
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initalState);
    }
    default: {
      return state;
    }
  }
};
